export default "/static/dashboard/build/app/img/v2/1f9a5933e702acd1fa1602b1ff0eb555.png";